import { ValidatorFn, AbstractControl, FormGroup } from "@angular/forms";
import { IUploadFile } from "../services/document-management.service";

export function requireOneOption(opts: boolean[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (opts.find(o => o === true) != null) return null;
        return { "searchOption": "required" };
    }
}

export function requireOneOfGroup(opts: string[]): ValidatorFn {
    return (grp: AbstractControl): { [key: string]: any } | null => {
        const group = grp as FormGroup;
        let valid: boolean = false;
        for (let c = 0; c < opts.length; c++) {
            let ctrl = group.get(opts[c]);
            valid = ctrl.value;
            if (valid) break;
        }       
        return (valid) ? null : { "optionGroup": "required" };
    }
}

export interface RequestForScanning {
    adhocRequestId?: string;
    apiNumber: string;
    applicationNumber: string;
    confidential: boolean;
    coversheetId?: string;
    coversheetType?: string;
    dateDocumentReceived: Date;
    documentType: string;
    files: IUploadFile[];
    groupRequesting: string;
    instructions: string;
    isAdhoc?: boolean;
    isPaperApplication: boolean;
    legalComments: string;
    legalReviewRequired: boolean;
    pages: number;
    documentGroup: string;
    organization: string;
    organizationName: string;
    rbdmsNumber: string;
    rejectReason: string;
    requestor: string;
    scanningComments: string;
    timeOfRequest: string;
    coversheetUrl?: string;
}


export enum ScanningSteps {
    Loading = "Data Loading",
    InitialScan = "Ready to Scan",
    LegalReview = "Legal Review",
    DocumentGroup = "Document Group Confirmation",
    ReturnedToScanning = "Returned to Scanning",
    Rejected = "Rejected by Document Group"
}

